$ = jQuery;

/**
 * Cliques em redes sociais para compartilhar o post
 */
$(".jc-post-social-media-share a").on('click', function() {

  dataLayer.push({
    'event': 'eventGA',
    'eventCategory': 'Redes Sociais',
    'eventAction': 'Clique - Compartilhar',
    'eventLabel': $(this).data('social-type')
  });

  gtag('event', 'Redes Sociais', {
    'eventAction': 'Clique - Compartilhar',
    'eventLabel': $(this).data('social-type')
  });
});
